import type { ReactNode } from 'react'

interface EmptyStateProps {
  icon?: ReactNode
  title: string
  description?: string
  action?: ReactNode
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-12 px-4 text-center">
      {icon && (
        <div className="text-secondary-300 mb-1">
          {icon}
        </div>
      )}
      <p className="text-sm font-medium text-secondary-700">{title}</p>
      {description && (
        <p className="text-xs text-secondary-400 max-w-[220px]">{description}</p>
      )}
      {action && <div className="mt-3">{action}</div>}
    </div>
  )
}
